module.exports = __webpack_public_path__ + "img/video.54035297.svg";